var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.175659C10.7453 0.175659 0 10.9209 0 24.1757C0 35.4307 7.74912 44.8752 18.2026 47.4691V31.5101H13.2538V24.1757H18.2026V21.0153C18.2026 12.8467 21.8995 9.06046 29.9194 9.06046C31.44 9.06046 34.0637 9.35902 35.137 9.65662V16.3046C34.5706 16.2451 33.5866 16.2153 32.3645 16.2153C28.4294 16.2153 26.9088 17.7062 26.9088 21.5817V24.1757H34.7482L33.4013 31.5101H26.9088V48C38.7926 46.5648 48.001 36.4464 48.001 24.1757C48 10.9209 37.2547 0.175659 24 0.175659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b5a2e72191c91f19277dfaf9e79ecc76.svg";
export { ForwardRef as ReactComponent };